import { createAction, props } from '@ngrx/store'
import { PartialAnswerDraft, SaleItemSurveyDraft } from './sale-item-survey-draft.model'

export const saleItemSurveyDraftActions = {
  upsertOne: createAction(
    '[SaleItemSurveyDraft] Upsert one',
    props<{ draft: SaleItemSurveyDraft }>()
  ),
  upsertMany: createAction(
    '[SaleItemSurveyDraft] Upsert many',
    props<{ drafts: SaleItemSurveyDraft[] }>()
  ),
  removeBySaleItemId: createAction(
    '[SaleItemSurveyDraft] Remove by sale item id',
    props<{ saleItemId: number }>()
  ),
  resetState: createAction('[SaleItemSurveyDraft] reset state')
}
